
<div class="nestedInnerItem">
  <cvt-select
    :value="componentData"
    mode="dropdown"
    :background-mode="mode"
    :floating-label="false"
    :label="alignmentLabel"
    @input="(value) => componentData = value"
  >
    <option
      v-for="style in alignmentStyles"
      :key="style"
      :value="style"
      v-text="style"
    />
  </cvt-select>
</div>
